import React from "react";

const getPhoneLink = (number) => {
  let theNumber = number.trim();
  if (theNumber.length === 7) {
    theNumber = `2${theNumber}`;
  }
  return `tel:+57${theNumber}`;
};

const getWhatsappLink = (number) => {
  const theNumber = number.length > 10 ? number : `+57${number}`;
  return `http://api.whatsapp.com/send?phone=${theNumber}`;
};

const useLinks = (place, venue) => {
  const [links, setLinks] = React.useState(null);
  React.useEffect(() => {
    const theLinks = [];
    if (venue && venue.phones) {
      venue.phones.forEach((phone) => {
        if (phone.phone) {
          theLinks.push({
            type: "phone",
            label: phone.number,
            url: getPhoneLink(phone.number),
          });
        }
        if (phone.whatsapp) {
          theLinks.push({
            type: "whatsapp",
            label: phone.number,
            url: getWhatsappLink(phone.number),
          });
        }
      });
    }
    if (place && place.links) {
      theLinks.push(...place.links);
    }
    setLinks(theLinks);
  }, [place, venue]);
  return links;
};

export {
  useLinks,
  getPhoneLink,
  getWhatsappLink,
};
